import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { hasSession } from '../helper';
import UserProvider from 'helper/UserContext';

const PrivateRoutes = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props =>
        hasSession() ? (
          <UserProvider>
            <Component />
          </UserProvider>
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

export default PrivateRoutes;
